import * as React from "react"

import { cn } from "@/lib/utils"

// Sensible mobile defaults per input type. These auto-apply unless the
// caller explicitly overrides them via props (see {...props} spread order).
// Fixes a recurring iOS/Android issue where users couldn't reliably type
// emails in popups due to missing inputMode / autoCapitalize.
const MOBILE_DEFAULTS = {
  email: {
    inputMode: "email",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: "false",
    autoComplete: "email",
  },
  tel: {
    inputMode: "tel",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: "false",
    autoComplete: "tel",
  },
  url: {
    inputMode: "url",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: "false",
  },
  search: { inputMode: "search" },
  number: { inputMode: "numeric" },
};

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const defaults = MOBILE_DEFAULTS[type] || {};
  return (
    <input
      type={type}
      {...defaults}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
